import Layout from "../../components/blog/Layout";
import { getAllPostIds, getPostData, getSortedPostsData } from "../../lib/posts/abc-podatkow";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/pl";
import { ArticleJsonLd } from "next-seo";
import { serialize } from "next-mdx-remote/serialize";
import { MDXRemote } from "next-mdx-remote";
import Section from "../../components/Section";
import DeclarationBox from "../../components/DeclarationBox";
import DeclarationBoxItem from "../../components/DeclarationBoxItem";
import BackgroundSection from "../../components/BackgroundSection";
import SectionBox from "../../components/SectionBox";
import Author from "../../components/Author";
import Link from "next/link";
import BackButton from "../../components/BackButton";
import FAQ from "../../components/FAQ";
import {
	FloatVideo,
	DeclarationBoxIndividual,
	DeclarationModal,
} from "../../components/DynamicComponents";
import MDXComponents from "../../components/MDXComponents";

dayjs.extend(localizedFormat);
dayjs.locale("pl");

const components = {
	...MDXComponents,
	FloatVideo,
	DeclarationBoxIndividual,
	BackgroundSection,
	SectionBox,
	Section,
	FAQ,
};

export async function getStaticPaths() {
	const paths = getAllPostIds();
	return {
		paths,
		fallback: false,
	};
}

export async function getStaticProps({ params }) {
	const postData = await getPostData(params.id);
	const allPostsData = getSortedPostsData();

	const mdxSource = await serialize(postData.contentHtml, {
		mdxOptions: {
			remarkPlugins: [],
			rehypePlugins: [],
		},
	});

	return {
		props: {
			postData,
			allPostsData,
			source: mdxSource,
		},
	};
}

export default function Post({ postData, allPostsData, source }) {
	let blogMiasto = "PRZYJAZNEDEKLARACJE";
	let blogPodatek = postData.blogPodatek;

	return (
		<Layout
			article
			title={postData.title}
			description={postData.description}
			seoTitle={postData.seoTitle}
			seoDescription={postData.seoDescription}
			seoImage={postData.seoImage}
			imageDesktop={postData.imageDesktop}
			imageTablet={postData.imageTablet}
			imageMobile={postData.imageMobile}
			datePublication={postData.datePublication}
			dateUpdate={postData.dateUpdate}
			hours={postData.hours}
			author={postData.author}
			authorVariable={postData.authorVariable}
			blogMiasto={postData.blogMiasto}
			blogPodatek={postData.blogPodatek}
			blogWithAction={postData.blogWithAction}
			blogActionText={postData.blogActionText}
			blogActionUrl={postData.blogActionUrl}
		>
			<ArticleJsonLd
				url={`https://przyjazne-deklaracje.pl/abc-podatkow/${postData.id}/`}
				title={postData.title}
				description={postData.description}
				images={[postData.imageMobile, postData.imageTablet, postData.imageDesktop]}
				datePublished={postData.datePublication}
				dateUpdate={postData.dateUpdate}
				authorName={postData.author}
				publisherName="Przyjazne Deklaracje"
				publisherLogo="https://przyjazne-deklaracje.pl/resources/images/logo/przyjazne-deklaracje/logo-desktop.svg"
			/>

			<section className="pd-article__container">
				<article className="pd-article">
					<MDXRemote {...source} components={components} />

					<div className="pd-article__dialog">
						<div className="pd-article__dialog__wrapper">
							{postData.dialog == "only" && <DeclarationModal miasto={postData.blogMiasto} />}

							{postData.dialog == "full" && (
								<Section id="wypelnij-deklaracje" title="sections.wypelnijdeklaracje.title">
									<DeclarationBox center>
										<DeclarationBoxItem
											miasto={postData.blogMiasto}
											podatek={postData.blogPodatek}
											noReadMore
										/>
									</DeclarationBox>
									<DeclarationModal miasto={postData.blogMiasto} />
								</Section>
							)}
						</div>
					</div>

					<aside className="pd-entries__popular absolute">
						<div className="pd-entries__max-width">
							{postData.author != "Redakcja" && (
								<>
									<h2 className="pd-entries__title">Autor artykułu:</h2>
									<Author miasto={blogMiasto} author={postData.authorVariable} />
								</>
							)}
							<h2 className="pd-entries__title">Podobne wpisy:</h2>
							{allPostsData
								.filter((item) => item.id !== postData.id)
								.slice(0, 3)
								.map(({ id, datePublication, title, author }, index) => (
									<article key={index} className="pd-entry">
										<header className="pd-entry__header">
											<h3 className="pd-entry__title">
												<Link
													href={`/abc-podatkow/${id}/`}
													aria-label={"Czytaj więcej o " + title.toLowerCase()}
												>
													{title}
												</Link>
											</h3>
										</header>
										<p className="pd-entry__meta">
											<span className="pd-entry__meta__date">
												<time dateTime={dayjs(datePublication).format("YYYY-MM-DD")}>
													{dayjs(datePublication).format("D MMMM YYYY")}
												</time>
											</span>
											<span className="pd-entry__meta__author">{author}</span>
										</p>
										<footer className="pd-entry__footer">
											<Link
												href={`/abc-podatkow/${id}/`}
												aria-label={"Czytaj więcej o " + title.toLowerCase()}
												className="pd-entry__readmore"
											>
												Czytaj więcej
											</Link>
										</footer>
									</article>
								))}
						</div>
					</aside>
				</article>
			</section>

			<Section>
				<BackButton />
			</Section>
		</Layout>
	);
}
